module.exports = "/fonts/salesforce-sans.eot?49e615b0930c7385209e36c8c185bb6b";